<template>
  <div name="test" class="board" style="width: 100%;height: 100dvh;display: flex;justify-content: center; align-items: flex-start;z-index: 0;">
    <iframe 
    id="myIframe"
      src="https://in-app.showcase.soldoc.co.kr/booking/profile?data=%7B%22type%22%3A%22SOLDOC_TEST%22[…]artment%22%3A%7B%22type%22%3A%22DEPARTMENT%22%7D%7D%7Dp"
      style="width: 500px; height: 100%; border: 0;z-index: 1;background: #fff;"
    />
  </div>
</template>

<script>
export default { 
    methods: {
      sendMessage: function()
      {
        const targetWindow = document.getElementById("myIframe").contentWindow;
        const data = { type: "EXTERNAL_DATA", device: "BLOOD_PRESSURE", message: {high: 120, low: 80} };
        targetWindow.postMessage(data, "http://localhost:8080");
      }
    }

}
</script>

<style scoped>
  .board {
    background: red;
  }
</style>


// WEBPACK FOOTER //
// src/page/test/index.vue